export const GRID_STYLES = `
  .react-grid-item.react-grid-placeholder {
    background: rgb(236 72 153 / 0.2) !important;
    border: 2px dashed rgb(236 72 153) !important;
    border-radius: 12px !important;
  }
  
  .react-grid-item.react-draggable-dragging {
    transition: none !important;
    z-index: 3 !important;
    opacity: 0.9 !important;
  }
  
  .react-grid-item.resizing {
    opacity: 0.8 !important;
    z-index: 3 !important;
    transition: none !important;
    pointer-events: none !important; /* prevent inner content from capturing events while resizing */
  }
  
  .react-grid-item > .react-resizable-handle {
    background: transparent !important;
    width: 24px !important;
    height: 24px !important;
    bottom: 0 !important;
    right: 0 !important;
    z-index: 10 !important;
    cursor: se-resize !important;
    touch-action: none !important;
    user-select: none !important;
  }
  
  .react-grid-item > .react-resizable-handle::after {
    content: '';
    position: absolute;
    right: 2px;
    bottom: 2px;
    width: 14px;
    height: 14px;
    border-right: 2px solid rgb(156 163 175);
    border-bottom: 2px solid rgb(156 163 175);
    border-radius: 0 0 12px 0;
    opacity: 0.5;
    transition: all 0.2s ease;
  }
  
  .react-grid-item:hover > .react-resizable-handle::after {
    border-color: rgb(236 72 153);
    opacity: 1;
  }
  
  .react-grid-item {
    transition: all 200ms ease !important;
  }
  
  /* Contain scroll chaining inside the grid */
  .react-grid-layout {
    overscroll-behavior: contain !important;
  }
  
  .drag-handle:hover {
    background: rgb(236 72 153 / 0.1) !important;
  }
`;
